<template>
  <modal name="download-price-modal" height="auto" width="480px" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="clear(); $modal.hide('download-price-modal')"  alt="">
    </div>
    <div class="modal-form">
      <div class="input-block">
        <br>
        <app-select :options="providers" :value="provider" @input="changeProvider($event)" placeholder="Поставщики"/>
        <br>
        <h4>Категории</h4>
        <loading-container :loading="loading" height="99">
          <div style="background-color: white;">
            <tree :data="catalog" :key="key"  @node:checked="select" @node:unchecked="select"/>
          </div>
        </loading-container>
        <span class="text-danger text-sm" v-if="select_error">{{ select_error }}</span>
      </div>
      <div class="btn">
        <button style="margin-top: 16px;" @click="download()">Скачать</button>
      </div>
    </div>
  </modal>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import AppSelect from "@/components/app-select";

export default {
  name: "download-price-modal",
  components: {AppSelect, LoadingContainer },
  data: ()=> ({
    catalog: [],
    providers: [],
    select_error: '',
    loading: false,
    provider: '',
    key: 1,
    selected: []
  }),
  methods: {
    open(providers){
      if (providers) {
        this.providers = providers;
        this.$modal.show('download-price-modal');
      }
    },
    clear(){
      this.provider = '';
      this.catalog = [];
      this.key++;
      this.select_error = '';
      this.selected = [];
    },
    select(val) {
      this.selected = [];
      val.tree.checkedNodes.forEach((item)=>{
        this.selected.push(item.id)
      })
    },
    changeProvider(val) {
      this.provider = val;
      this.getCategories();
    },
    getCategories() {
      this.loading = true;
      this.$http.post( '/get-all-categories',{
        token: localStorage.getItem('token'),
        provider: this.provider ? this.provider.id : ''
      }).then(({data}) => {
        if (data.categories) {
          this.catalog = data.categories;
          this.key++;
        }
      }).catch(function(){
        this.$toast.error('Ошибка!');
      })
      .finally(()=> this.loading = false)
    },
    download(){
      this.select_error = '';

      if (this.selected.length == 0) {
        this.select_error = 'Выберите категории';
      }

      if (!this.provider) {
        this.select_error = 'Выберите поставщика';
      }

      let categories = this.selected.join(',');

      location.href = `${process.env.VUE_APP_BACKEND_URL}/export-price?provider=${this.provider.id}&token=${localStorage.getItem('token')}&categories=${categories}`
    }
  }
}
</script>

<style scoped lang="scss">

.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
